import React from 'react';

import { ChevronDown } from 'lucide-react';

import { fieldFrame } from './fieldFrame';
import { cn } from './utils';


/** Native select styled to the DESIGN.md `input` token (chevron per the .pen
 * Add Part selects). Pass options as children.
 *
 * `className` styles the wrapper span; `selectClassName` styles the inner
 * <select> directly, so consumers can override the control's height/radius/etc.
 * without reaching in via descendant-selector class hacks. */
const Select = React.forwardRef((props, ref) => {
  const {
    className, selectClassName, invalid = false, children, ...restProps
  } = props;

  return (
    <span className={cn('relative block w-full', className)}>
      <select
        ref={ref}
        className={cn(
          fieldFrame({ focus: 'visible', invalid }),
          'h-10 w-full cursor-pointer appearance-none pl-3 pr-8',
          'text-sm font-medium text-ink outline-none',
          'disabled:cursor-not-allowed disabled:opacity-50',
          selectClassName,
        )}
        {...restProps}
      >
        {children}
      </select>

      <ChevronDown
        className="pointer-events-none absolute right-2.5 top-1/2 size-4 -translate-y-1/2 text-ink-subtle"
      />
    </span>
  );
});

Select.displayName = 'Select';
export { Select };
export default Select;
